/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-20",
    versionChannel: "nightly",
    buildDate: "2023-06-20T00:20:10.263Z",
    commitHash: "18fb5064d3c0244b82cfbee428759bc2a76aafbc",
};
